module.exports = __webpack_public_path__ + "img/9-min.b4c8eddf.jpg";